import { createMakeTrafficSlice } from '@make-software/tg-mini-app-ui';

const { reducer, fetchTasks, selectTask, clearMakeTrafficError, resetMakeTrafficState } =
  createMakeTrafficSlice<{ userID: string; authProvider: string }>(
    ({ userID, authProvider }, manager) => manager.getTasks(userID, { authProvider })
  );

export { fetchTasks, selectTask, clearMakeTrafficError, resetMakeTrafficState };
export default reducer;
